import React from "react";

import { ReactComponent as Call } from "../../../Assets/Images/Icon/CallSmallICON.svg";
import { ReactComponent as Mail } from "../../../Assets/Images/Icon/MailSmallICON.svg";
import { SuperAdmin } from "../../../Constants/AppContants";
import { Theme } from "../../../Style/Theme";
import { Text9 } from "../../atoms/Typography/Text/Text";
import { Message } from "../../organisms/Message/Message";
import { ConfirmMessageBoxType2 } from "../../templates/MessageBox/ConfirmMessageBox/ConfirmMessageBox";

export const ContactSupport = ({ visible, close, t, userRoleName }) => {
  var mail =
    userRoleName == SuperAdmin
      ? "support@firstdoctor.org"
      : "support@firstdoctor.org";

  return (
    <ConfirmMessageBoxType2
      buttonspace={3}
      isOpen={visible}
      close={close}
      heading={t("glossary:auth.support.title")}
      positiveButtonAction={() => {
        window.open(`mailto:${mail}`, `_self`);
      }}
      positiveButton={
        <Text9
          icon={<Mail />}
          text={mail}
          color={Theme.palette.blue.primaryBlue}
        />
      }
      negativeButton={
        <Text9
          icon={<Call />}
          text={"0112 595 939"}
          color={Theme.palette.blue.primaryBlue}
        />
      }
      negativeButtonAction={() => {
        window.open("tel:0112 595 939", "_self");
      }}
    >
      <Message name={t("glossary:auth.support.heading")} />
    </ConfirmMessageBoxType2>
  );
};
